module.exports = __webpack_public_path__ + "img/re-create.8fd491f7.png";